import { createContext, useContext } from "react";
import { ScreenerTransactionsParams } from "@api/token-screener/screener-transactions.ts";

export const getDefaultFilters = (): ScreenerTransactionsParams["filters"] => {
  return {};
};

export const TransactionHistoryFilterContext = createContext<{
  filters: ScreenerTransactionsParams["filters"];
  onFiltersUpdate: (filters: ScreenerTransactionsParams["filters"]) => void;
}>({ filters: getDefaultFilters(), onFiltersUpdate: () => {} });

export const useTransactionFilterProvider = () => {
  const context = useContext(TransactionHistoryFilterContext);
  if (!context) {
    throw new Error(
      "useTokenTransactionsFilter must be used within a TransactionHistoryFilterProvider",
    );
  }
  return context;
};
